var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgO(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 161,
    viewBox: "0 0 157 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M157.002 141.011L147.434 141.865L146.733 150.94L137.867 151.882L136.5 161H23L21 153C21 153 20.0408 148.998 20 149.011H13L10 139.011H3L0 129.011L8.00191 81.6691V22.3276C10.5238 21.8869 13.0143 21.3861 16.4369 20.7851C16.8371 18.2609 17.2775 15.4362 17.7979 12.0106H114.701L139 0L147.002 12.0106V20H149L157.002 32.0106V141.011ZM57.8875 51.8764V110.654H106.563V51.8764H57.8875Z",
    fill: "#F86C14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M149 129L139.432 129.855L138.731 138.93L129.865 139.871L128.464 148.886L20 149C19.4596 146.436 19.0428 143.277 18.3423 139.931C15.7203 139.651 13.1584 139.37 9.9961 139.01C9.55577 136.285 9.11545 133.461 8.57505 130.055L0 129V10.317C2.52186 9.87632 5.01242 9.3755 8.43495 8.7745C8.83524 6.25033 9.27557 3.42566 9.79595 0H139V18.3704L149 20V129ZM49.8856 39.8659V98.643H98.5616V39.8659H49.8856Z",
    fill: "#FFC700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgO);
export default __webpack_public_path__ + "static/media/O.4afb2ce4c14bc68b71e20e9c7387eefb.svg";
export { ForwardRef as ReactComponent };